import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const UndoIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M8.66667 15L2 10L8.66667 5"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 10H16.6667C18.0812 10 19.4377 10.4214 20.4379 11.1716C21.4381 11.9217 22 12.9391 22 14C22 15.0609 21.4381 16.0783 20.4379 16.8284C19.4377 17.5786 18.0812 18 16.6667 18H15.3333"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

UndoIcon.displayName = 'UndoIcon';
